import { Box } from "@mui/material";
import { FC, ReactNode } from "react";

interface AuthMainLayoutProps {
  children?: ReactNode;
}

export const AuthMainLayout: FC<AuthMainLayoutProps> = (props) => {
  const { children } = props;
  return (
    <Box
      component="main"
      sx={{
        flexGrow: 2,
        width: "-webkit-fill-available",
        overflow: " hidden",
        position: "relative",
      }}
    >

      <Box />
      {children}
      
    </Box>
  );
};
